import React from "react"
import logo from '../images/logo_negro.svg';
import logo_blanco from '../images/logo_white.png';


import { Input } from 'semantic-ui-react'

import player from '../images/player_user.svg';
import data from '../images/player_data.svg';

import close from '../images/close_icon.svg';


import menu from '../images/menu.png';
import { Link } from "gatsby"
import alert from '../images/alert.svg';
import upload from '../images/upload.svg';
import { navigate } from "gatsby-link";

import i1 from '../images/tb_1.svg';
import i2 from '../images/tb_2.svg';
import i3 from '../images/tb_3.svg';
import i4 from '../images/tb_4.svg';
import i5 from '../images/tb_5.svg';
import i6 from '../images/tb_6.svg';
import i7 from '../images/tb_7.svg';

import { getUser } from "../userHelper";

export default class UserTopbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      config: false,
      alerts: false,
    };
  }

  componentDidUpdate() {

    var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;

    if(width < 1440){
      navigate('/use-app')
    }

  }

  async componentDidMount() {

    var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;

    if(width < 1440){
      navigate('/use-app')
    }

    var user = this.props.user?.userObject;
   if(user == null){
     var cookieUser = localStorage.getItem('user');;
     if(cookieUser){
      //   console.log('cookie', cookieUser)
       await getUser(cookieUser).then(newuser => {
        //  console.log('newuser', newuser)
        if(!newuser){
          navigate('/login')
        } else {
          //user.updateUser(newuser);
          //  console.log(this.props.user)
          this.props.user.updateUser(newuser)
          // navigate('/user')
        }
      }).catch((error) => {
        //  console.log('error', error)
      })
     } else {
      navigate('/login')
     }
    }
  }


  openAlertsMenu(){
    this.setState({
      alerts: !this.state.alerts,
      config: false,
    })
  }

  logout(){
    if(window?.localStorage){
      window.localStorage.removeItem('user');
      navigate('/')
    }
  }

  openConfigMenu(){
    this.setState({
      config: !this.state.config,
      alerts: false,
    })
  }

  onMobileClick(ref){
    this.setState({
      open: false,
    })
    this.props.handlerNavigation(ref)
  }

  render(){
    return(
      <>
      <header>
        <div className="usertopbar">
          <div className="wrapper">
            <div>
            <Link to={'/feed'}>
              <img src={logo_blanco} className="nav--logo" alt="Troop"></img>
            </Link>
            <Input action={{ icon: 'options' }} icon='search' iconPosition='left' placeholder='Escribí el nombre de una troop/trooper' />  
            </div>
            <img src={this.state.open ? close : menu} onClick={() => this.openMobileTopbar()} className={"topbar--menu " + (this.state.open ? 'fixed' : '')}></img>
            <div className="row">
              <div>
              <div className="links--container">
                <div className="link--container box button--global green">
                  <Link to='/my-troops?create' className="nav--item">Creá tu Troop</Link>
                </div>
                <div className="link--container box button--global green">
                  <Link to='/tournaments' className="nav--item">Torneos</Link>
                </div>
                <div className="link--container box button--global yellow">
                  <Link to='/upgrade?checkout' className="nav--item">Hacete PRO</Link>
                </div>
              </div>
            </div>
            <div className="links--container">
            <Link to="/my-clips?create" className="topbar-icon-container">
              <img src={upload} />
            </Link>
            <div onClick={() => this.openAlertsMenu()} className="topbar-icon-container">
              <img src={alert} />
            </div>
            {this.state.alerts &&
              <div className="menu--topbar alerts--menu">
                <div className="profile-alert-container">
                  <div className="profile-picture-container menu">
                    <img src={this.props.profilePic || null} />
                  </div>
                  <p> <span> marcos55 </span> quiere unirse a <span> KZD Team. </span></p>
                </div>
                <hr/>
                <div className="profile-alert-container">
                  <div className="profile-picture-container menu">
                    <img src={this.props.profilePic || null} />
                  </div>
                  <p> <span> marcos55 </span> quiere unirse a <span> KZD Team. </span></p>
                </div>
                <hr/>
                <div className="profile-alert-container">
                  <div className="profile-picture-container menu">
                    <img src={this.props.profilePic || null} />
                  </div>
                  <p> <span> marcos55 </span> quiere unirse a <span> KZD Team. </span></p>
                </div>
                <hr/>
                <div className="profile-alert-container">
                  <div className="profile-picture-container menu">
                    <img src={this.props.profilePic || null} />
                  </div>
                  <p> <span> marcos55 </span> quiere unirse a <span> KZD Team. </span></p>
                </div>
                <hr/>
                <div className="profile-alert-container">
                  <div className="profile-picture-container menu">
                    <img src={this.props.profilePic || null} />
                  </div>
                  <p> <span> marcos55 </span> quiere unirse a <span> KZD Team. </span></p>
                </div>
                <hr/>
                <div className="profile-alert-container">
                  <div className="profile-picture-container menu">
                    <img src={this.props.profilePic || null} />
                  </div>
                  <p> <span> marcos55 </span> quiere unirse a <span> KZD Team. </span></p>
                </div>
                <hr/>
              </div>
            }
            <div onClick={() => this.openConfigMenu()} className="profile-picture-container">
              <img src={this.props.profilePic || null} />
            </div>
            {this.state.config &&
              <div className="menu--topbar config--menu">
                <Link to={'/user'} className="profile-menu-container">
                  <div className="profile-picture-container menu">
                    <img src={this.props.profilePic || null} />
                  </div>
                  <p className="username"> {this.props.user?.userObject?.username || 'waiting'} </p>
                </Link>

                <Link className="config--menu--item" to={'/my-troops'} ><img src={i1} />Mis troops</Link>
                <Link className="config--menu--item" to={'/my-clips'} ><img src={i2} />Mis clips</Link>
                <Link className="config--menu--item" to={'/following'} ><img src={i3} />Seguidos</Link>
                <hr/>
                <Link className="config--menu--item" to={'/tournaments'} ><img src={i4} />Mis torneos</Link>
                <Link className="config--menu--item" to={'/challenges'} ><img src={i5} />Desafíos</Link>
                <hr/>
                <Link className="config--menu--item" to={'/settings'} ><img src={i6} />Configuración</Link>
                <p onClick={() => this.logout()} className="config--menu--item" to={'/challenges'} ><img src={i7} />Cerrar sesión</p>
              </div>
            }
            </div>
            {this.state.open &&
              <div className="links--container--mobile">
                <div className="link--container">
                  <Link to='/' className="nav--item">HOME</Link>
                </div>
                <div className="link--container">
                  <Link to='/sobre-troop' className="nav--item">QUÉ ES TROOP</Link>
                </div>
                <div className="link--container">
                <Link to='/troop-pro' className="nav--item">PRO</Link>
                </div>
                <div className="link--container">
                <Link to='/preguntas-frecuentes' className="nav--item">FAQ</Link>
                </div>
                <div className="link--container">
                <Link to='/troop-cup' className="nav--item">TROOP CUP 21</Link>
                </div>
              </div>
            }
            </div>
          </div>
      {this.props.player &&
      <div className="player">
        <div className="wrapper app">
          <div className="name">
            <img src={player} />
            <img onClick={() => this.props.onClose()} className="close" src={close} />
          </div>
          <img src={data} />
        </div>
      </div>
      }
        </div>
      </header>
      </>
    );
  }
}
